import { get } from 'svelte/store';
import { viewport } from './stores/viewport';

/**
 * Hover popovers (DayCellPopover, ProjectCellPopover) render as bottom sheets on
 * mobile (plans/mobile-v2.md §3.4). Their stores use these helpers to switch from
 * hover semantics to sheet semantics there:
 *
 * - A sheet stays open until it is dismissed (backdrop, swipe, Esc, an action).
 *   The `mouseleave` a phone fires on the next tap must not close it.
 * - A tap fires an emulated `mouseenter` before its `click`. When that click
 *   opened a dialog (edit event, a rail…), the delayed hover show is dropped
 *   instead of stacking a second sheet on top of it.
 */
export function popoversAreSheets(): boolean {
  return get(viewport).isMobile;
}

/**
 * True while a modal dialog (an open sheet or modal) is on screen.
 *
 * A global DOM query that relies on `aria-modal="true"` being set only while a
 * dialog is open (MobileSheet sets it only when `open`). An always-mounted
 * `aria-modal` element would make every mobile hover show get dropped.
 */
export function isModalDialogOpen(): boolean {
  if (typeof document === 'undefined') return false;
  return !!document.querySelector('[role="dialog"][aria-modal="true"]');
}
